import React from 'react';
import styles from './orgs_about.less';

const OrgsAbout = () => {
  return (
    <div className={styles.about}>
      <h2>About Our Partner Organizations</h2>
      <p>
        Omnia Fishing partners with many great organizations to make sure we not only have the best
        fishing products to offer, but to give you the best fishing recommendations no matter where
        you go or what species you target. Our partners help us do this by submitting fishing
        reports as a member of their respective organizations page on our site.
      </p>
      <p>
        Each organization has a page on our site where all of the members' fishing reports are
        collectively displayed and each individual member has a personalized page as well. We also
        offer special promotions and incentives for each organization we work with.
      </p>
      <p>
        Listed below are links to all of our partnering organizations. To learn more about the
        benefits your team or organization can take advantage of by partnering with us, please reach
        out via email to <a href="mailto:ricky@omniafishing.com">ricky@omniafishing.com</a>.
      </p>
    </div>
  );
};

export default OrgsAbout;
